import { AwardingClient } from "@/utils/EvoClient";
import { AddMessageAttachmentDto } from "../dto";
import { AxiosResponse } from "axios";

const ENDPOINT = "c/add-message-attachment";

export default async function addMessageAttachment(
  dto: AddMessageAttachmentDto
): Promise<string> {
  return ((await AwardingClient.post(ENDPOINT, dto)) as AxiosResponse).data.id;
}
